import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider } from '@/lib/auth'
import { Providers } from '@/app/providers'
import { App } from '@/app/App'
import { installPreloadReload } from '@/lib/app-update'
import './index.css'

// До первого ленивого импорта: карта и сканер — отдельные чанки.
installPreloadReload()

const root = document.getElementById('root')
if (!root) throw new Error('#root не найден')

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <Providers>
        <App />
      </Providers>
    </AuthProvider>
  </StrictMode>,
)
